module.exports = __webpack_public_path__ + "img/slide-4.10980929.jpg";